// extracted by mini-css-extract-plugin
module.exports = {"background":"Error_background__2wXJ4","container":"Error_container__1Vsqp","close":"Error_close__1y38N","displayNone":"Error_displayNone__3B0Hx"};